import type { FC, SVGAttributes } from 'react';

const SplitLogo: FC<SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      width='12'
      height='14'
      viewBox='0 0 12 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.5595 11.8587L11.5506 11.8407L11.5418 11.8227L11.5329 11.8047V11.7868L11.5153 11.7688V11.7508L11.5064 11.7329L11.4887 11.7239L11.4799 11.6969H11.4887L11.4799 11.679L11.471 11.661V11.643L11.4534 11.6251L11.471 11.6161L11.4445 11.5801V11.5711L11.4357 11.5532L11.418 11.5172L11.4003 11.4903H11.4091V11.4723L11.3915 11.4543L11.4091 11.4454L11.3738 11.3914L11.3561 11.3735V11.3465L11.3472 11.3285L11.3384 11.3106L11.3207 11.2657L11.3119 11.2477L11.2942 11.1938L11.2853 11.1758V11.1578L11.2677 11.1399V11.1129C11.2633 11.1056 11.2572 11.0994 11.25 11.0949C11.25 11.0949 11.2235 11.0051 11.1616 10.8613L8.91556 5.41642L8.93324 5.39845C12.1696 2.79279 11.7894 2.41543 11.7894 2.41543C10.6131 1.12008 8.98531 0.343035 7.25317 0.25004C5.51843 0.159735 3.81666 0.755454 2.50475 1.91227C2.30242 2.08951 2.11326 2.28172 1.93883 2.48731C1.75266 2.70497 1.57849 2.93294 1.41712 3.17017C0.566193 4.43706 0.161667 5.95901 0.269215 7.48895C0.376762 9.01888 0.990069 10.467 2.00957 11.5981C2.72424 12.377 3.61084 12.9722 4.59631 13.3346C5.58177 13.697 6.63788 13.8163 7.67761 13.6826C9.06994 13.5363 10.3817 12.9485 11.4268 12.0024L11.471 11.9665L11.5595 11.8766V11.8497V11.8587Z'
        fill='url(#paint0_radial_71087_4052)'
      />
      <path
        d='M8.8449 5.4613L8.4293 5.8207C7.347 6.70756 6.25038 7.57623 5.13989 8.42635C6.21863 9.60486 7.47164 10.6052 8.85374 11.3914C10.0298 12.0383 10.9583 12.1641 11.4181 11.7508C11.869 11.3465 11.816 10.4031 11.2854 9.18109C10.6598 7.82402 9.83707 6.57011 8.8449 5.4613Z'
        fill='url(#paint1_linear_71087_4052)'
      />
      <path
        d='M8.93341 5.39844L8.42939 5.81175C9.35865 6.84869 10.1305 8.02064 10.7196 9.28894C11.2325 10.5019 11.2236 11.1129 11.0556 11.2656C10.8876 11.4184 10.1714 11.4543 9.01299 10.8344C7.73616 10.1005 6.58128 9.16659 5.59094 8.06698L5.02502 8.48928L5.15766 8.62405C7.55398 11.1399 10.1537 12.5775 11.2944 12.0563L11.3916 12.0024H11.4093L11.5331 11.9126L11.6481 11.7868C12.3908 10.7894 11.259 8.10292 8.99531 5.48829L8.93341 5.39844Z'
        fill='#84EEB1'
      />
      <defs>
        <radialGradient
          id='paint0_radial_71087_4052'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(8.97746 1.23839) scale(29.5767 22.9026)'
        >
          <stop stopColor='#48F56D' />
          <stop offset='0.09' stopColor='#43EA68' />
          <stop offset='0.25' stopColor='#37CB5A' />
          <stop offset='0.44' stopColor='#239A44' />
          <stop offset='0.62' stopColor='#085625' />
          <stop offset='0.8' stopColor='#00421C' />
        </radialGradient>
        <linearGradient
          id='paint1_linear_71087_4052'
          x1='9.38429'
          y1='16.5398'
          x2='6.83865'
          y2='-1.46401'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.1' stopColor='#FF8475' />
          <stop offset='0.37' stopColor='#E84E43' />
          <stop offset='0.6' stopColor='#D6261F' />
          <stop offset='0.79' stopColor='#CC0E08' />
          <stop offset='0.9' stopColor='#C80500' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SplitLogo;
